import { render } from "./Consultant.vue?vue&type=template&id=71fabf9e&scoped=true"
import script from "./Consultant.vue?vue&type=script&lang=js"
export * from "./Consultant.vue?vue&type=script&lang=js"

import "./Consultant.vue?vue&type=style&index=0&id=71fabf9e&scoped=true&lang=css"

import exportComponent from "D:\\pro\\node-workspace\\machitabi_Vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fabf9e"]])

export default __exports__